<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import RadioCard from 'dashboard/components-next/radioCard/RadioCard.vue';
import Checkbox from 'dashboard/components-next/checkbox/Checkbox.vue';
import { DEFAULT_TASK_LIST_FORMAT } from 'kanban/constants/reports';

// Escolha do formato da lista de cartoes e do recorte pelo periodo; quem chama faz a exportacao.
defineProps({
  isExporting: { type: Boolean, default: false },
});

const emit = defineEmits(['export']);

const { t } = useI18n();
const dialogRef = ref(null);
const fileFormat = ref(DEFAULT_TASK_LIST_FORMAT);
const createdInPeriod = ref(false);

const formatOptions = computed(() => [
  {
    value: 'xlsx',
    label: t('KANBAN.REPORTS.EXPORT.TASK_LIST.FORMAT_XLSX'),
    description: t('KANBAN.REPORTS.EXPORT.TASK_LIST.FORMAT_XLSX_HINT'),
  },
  {
    value: 'csv',
    label: t('KANBAN.REPORTS.EXPORT.TASK_LIST.FORMAT_CSV'),
    description: t('KANBAN.REPORTS.EXPORT.TASK_LIST.FORMAT_CSV_HINT'),
  },
]);

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();

defineExpose({ open, close });

const onConfirm = () => {
  emit('export', {
    fileFormat: fileFormat.value,
    createdInPeriod: createdInPeriod.value,
  });
};
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('KANBAN.REPORTS.EXPORT.TASK_LIST.TITLE')"
    :description="t('KANBAN.REPORTS.EXPORT.TASK_LIST.DESCRIPTION')"
    :confirm-button-label="t('KANBAN.REPORTS.EXPORT.TASK_LIST.CONFIRM')"
    :is-loading="isExporting"
    :ignore-click-outside="isExporting"
    @confirm="onConfirm"
  >
    <div class="flex flex-col gap-4">
      <div class="grid gap-3 sm:grid-cols-2">
        <RadioCard
          v-for="option in formatOptions"
          :id="`task-list-format-${option.value}`"
          :key="option.value"
          name="task-list-format"
          :label="option.label"
          :description="option.description"
          :is-active="fileFormat === option.value"
          @select="fileFormat = option.value"
        />
      </div>
      <label class="flex items-start gap-2 cursor-pointer">
        <Checkbox v-model="createdInPeriod" class="mt-0.5" />
        <span class="flex flex-col gap-0.5">
          <span class="text-sm text-n-slate-12">
            {{ t('KANBAN.REPORTS.EXPORT.TASK_LIST.CREATED_IN_PERIOD') }}
          </span>
          <span class="text-xs text-n-slate-11">
            {{ t('KANBAN.REPORTS.EXPORT.TASK_LIST.CREATED_IN_PERIOD_HINT') }}
          </span>
        </span>
      </label>
    </div>
  </Dialog>
</template>
